export default __webpack_public_path__ + "static/media/ninecasino.87e5e4e5.svg";